import React from 'react';
import {isEqual} from 'lodash';
import {CommonDataConsumer} from 'contexts/CommonDataContext';

import {SelectBase} from 'components/Forms/FormBases';
import {orderBy} from 'lodash/collection';

class SelectCountry extends React.Component {
  static defaultProps = {
    isClearable: true,
    name: 'countries_id',
    placeholder: 'Filter by Economy',
  };

  getOptions = (countries) => {
    return orderBy(countries, ['name'], 'asc').map((country) => {
      return {
        value: country.countries_id,
        label: country.name,
        code: country.code,
      };
    });
  };

  render() {
    const {value, ...rest} = this.props;

    return (
      <CommonDataConsumer>
        {({countries}) => {
          const options = this.getOptions(countries);

          return (
            <SelectBase
              defaultValue={options.find((option) =>
                isEqual(option.value, value)
              )}
              options={options}
              {...rest}
            />
          );
        }}
      </CommonDataConsumer>
    );
  }
}

export default SelectCountry;
